import template from './parking-purpose.jade';
import items from '../../../enums/parking-purpose';

export default angular
    .module('cian.addForm.aboutObjectParkingPurpose', ['cian.addForm.fieldTypeSwitcher'])
    .directive('cianAfAboutObjectParkingPurpose', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {
            this.items = items;
        },
        controllerAs: 'parking',
        template,
    }))
    .name;
